<template>
  <div class="header-bar">
    <div class="header-bar__user">
      <ul class="clearfix">
        <li
          v-if="dropDown"
          class="header-bar__item"
        >
          <span class="header-bar__item_ch">{{ cityName }}</span>
        </li>
        <li
          v-else
          class="header-bar__item"
          @click.stop="onToggleCity"
        >
          <span class="header-bar__item_ch">{{ cityName }}</span>
          <i
            class="header-bar__city_normal"
            :class="flag ? 'header-bar__city_active' : ''"
          ></i>
        </li>2222
        <li
          v-if="isLogin && newUnion"
          class="header-bar__item"
        >
          11111
          <a :href="userCenterURL" target="_self">
            <img
              v-if="messageCount"
              src="./imgs/bell_spots.png"
              style="width: 22px; height: 22px;"
            />
            <img
              v-else
              src="./imgs/bell.png"
              style="width: 22px; height: 22px;"
            />
          </a>
        </li>
        <li
          v-if="isLogin"
          class="header-bar__item"
        >
          <a :href="userCenterURL" target="_self">
            <i class="header-bar__icon_people"></i>
            <span class="header-bar__item_ch">{{ userMobile }}</span>
          </a>
        </li>
        <li class="header-bar__item">
          <a :href="userCenterURL" target="_self">
            <span class="header-bar__item_ch">{{TLang('个人中心','my')}}</span>
            <span class="header-bar__item_en">User Center</span>
          </a>
        </li>
        <li
          v-if="isLogin"
          class="header-bar__item"
        >
          <a @click="onLogout">
            <span class="header-bar__item_ch">{{TLang('退出账号','my')}}</span>
            <span class="header-bar__item_en">Sign Out</span>
          </a>
        </li>
      </ul>
    </div>
    <def-city
      v-show="flag"
      :allCities="allCities"
      :hotCities="hotCities"
      top="28px"
      @onHideCity="onHideCity"
    />
  </div>
</template>

<script>
import { removeCookie, cookieKeys, unionFlag } from './../../utils';
import Cookies from 'js-cookie';
import cache from '@utils/cache';
export default {
  components: {
    DefCity: () => import('./DefCity'),
  },
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
    loginData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      allCities: [],
      hotCities: [],
      cityName: (Cookies.get('address') &&
          JSON.parse(Cookies.get('address') || '{}').cityName) || this.TLang('上海', 'my'),
      flag: false,
      dropDown: false,
      loginInfo: {},
      df_lang: Cookies.get('df_lang'),
    };
  },
  computed: {
    newUnion() {
      const { newUnion } = this.unionHead;
      return newUnion;
    },
    messageCount() {
      const { messageCount } = this.unionHead;
      return messageCount;
    },
    userMobile() {
      const { loginUserMobile } = this.loginData;
      return loginUserMobile;
    },
    userCenterURL() {
      const { userCenter } = this.unionHead;
      return userCenter;
    },
    logoutURL() {
      const { logoutUrl } = this.loginData;
      return logoutUrl;
    },
    isLogin() {
      const { loginFlag } = this.loginData;
      return loginFlag;
    },
  },
  watch: {
    $route(newVal, oldVal) {
      const arr = ['packageDetails', 'OrganDetails'];
      if (oldVal.query.city && oldVal.query.city !== newVal.query.city) {
        this.getCityData();
      }

      this.dropDown = arr.includes(newVal.name);
    },
  },
  created() {
    // 获取城市数据
    this.getCityData();
    this.getLoginStatus();
  },
  mounted() {
    document.addEventListener('click', this.onHideCity);
    this.$bus.$on('changeCity', this.onToggleCity);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onHideCity);
    this.$bus.$off('changeCity', this.onToggleCity);
  },
  methods: {
    getCityData() {
      this.apis.headerApi.getCityData().then(res => {
        this.allCities = res.cityList;
        this.hotCities = res.hotCities;
        // this.cityName = res.cityName;
        if (this.df_lang && this.df_lang == 'en-US' || window.union_isBilingual) {
          this.getCityPinyin();
        }
      });
    },
    getCityPinyin() {
      if (this.allCities && this.allCities.length > 0) {
        this.allCities.forEach(i => {
          if(i.name == this.cityName) {
            this.cityName = i.pinyin;
          }
        });
      }
    },
    onToggleCity() {
      this.flag = !this.flag;
    },
    onHideCity() {
      this.flag = false;
    },
    getLoginStatus() {
      this.apis.headerApi.getLoginStatus().then(res => {
        this.loginInfo = res;
        cache.session.set('loginInfo', res);
      });
    },
    onLogout() {
      let cookies = cookieKeys();
      let { hostname } = window.location;
      cookies.forEach(item =>
        removeCookie(item, '/', `${hostname.substr(hostname.indexOf('.'))}`),
      );
      cookies = cookieKeys();
      cookies.forEach(item => removeCookie(item, '/', `.${hostname}`));
      cookies.forEach(item => removeCookie(item, '/', hostname));
      cookies.forEach(item => {
        document.cookie=item+'=;expires=' + new Date(0).toUTCString()+"; path=/";
      })
      if(unionFlag() === 'chailesemanager'){
      // if(unionFlag() === 'bfd'){
        this.apis.headerApi.getLoginOut().then(res => {
          window.location.href = this.loginInfo.logoutUrl;
        });
      }
      window.location.href = this.loginInfo.logoutUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  position: relative;
  z-index: 1;
  height: 28px;
  line-height: 28px;
  min-width: 1200px;
  .wrapper();
  &__user {
    text-align: right;
    height: 28px;
    > ul {
      display: inline-block;
    }
  }
  &__item {
    float: left;
    color: #1c4a9c;
    margin-left: 15px;
    font-size: 14px;
    > a {
      color: #1c4a9c;
    }
    &_en:before {
      content: "/";
      position: relative;
      top: -1px;
      padding: 0 1px;
    }
  }
  &__city {
    &_normal {
      position: relative;
      top: 1px;
      display: inline-block;
      vertical-align: middle;
      width: 0;
      height: 0;
      line-height: 0;
      font-size: 0;
      border-width: 4px;
      border-style: solid;
      border-color: #1c4a9c transparent transparent;
      transition: all 0.3s ease-in-out;
      margin-left: 3px;
    }
    &_active {
      transform: rotate(180deg) translateY(50%);
    }
  }
}
</style>
